/**
 * Parses and removes inline style tags via regex
 *
 * @param htmlString String of raw HTML
 */
export const removeInlineStyleTags = (htmlString: string) => {
    const cleanedHtml = htmlString.replace(/(<[^>]+) style=".*?"/g, '$1');

    return cleanedHtml;
};

/**
 * Replaces empty paragraphs and paragraphs with just a non-breaking space or a regular space with <br />
 *
 * @param htmlString String of raw HTML
 */
export const replaceEmptyParagraphsWithBr = (htmlString: string) => {
    let cleanedHtml = htmlString.replace(/<p><\/p>/g, '<br />');
    // \u00A0 = non-breaking space (U+00A0); \u0020 = regular space
    cleanedHtml = cleanedHtml.replace(/<p>[\u0020\u00A0]<\/p>/g, '<br />');
    return cleanedHtml;
};

/**
 * Places <br /> after each paragraph
 *
 * @param htmlString String of raw HTML
 */
export const placeLineBreaksAfterParagraphs = (htmlString: string) => {
    const cleanedHtml = htmlString.replace(/<\/p>/g, '</p><br />');

    return cleanedHtml;
};
